import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

const instance = axios.create({
	baseURL: `${process.env.VUE_APP_BACKEND_URL}/api/v1`,
	xsrfCookieName: "csrftoken",
	xsrfHeaderName: "X-CSRFToken",
});

export default instance;
